import React from "react";
import { skillsSection } from "../data/data";

const jsSkill = skillsSection.skills.find((skill) => skill.id === "js");

const SkillJS = () => (
  <div>
    <p>{jsSkill.details}</p>
  </div>
);

export default SkillJS;
